<template>
    <div>
        <div>
            <div class="flex items-center">
                <div class="flex-width flex items-center">
                    
                </div>
                <div class="flex" style=""> 
                    <a-input-search size="small" allowClear class="" v-model="search" placeholder="请输入关键字" enter-button @change="allowCostClear" @search="getCompanyDocuments" @pressEnter="getCompanyDocuments"/>
                    <a-button class="ml10" size="small" style="background-color: #fd6363;color: white;" icon="plus" @click="showAddUpload">
                        新增
                    </a-button>
                </div>
            </div>
        </div>
        <div class="mt15">
            <a-table size="small" :columns="columns" :data-source="projects" bordered :pagination="{ pageSize: 30 }">
                <template slot="sub" slot-scope="row">
                    <div style="color: #548ffc;" class="cursor-pointer one-line" @click="seeDetail(row)">
                        {{row.title}}
                    </div>
                </template>
                <template slot="status" slot-scope="row">
                    <div v-if="row.record_id != 0">
                        已阅
                    </div>
                    <div v-else style="color:red">
                        待阅
                    </div>
                </template>
                <template slot="create_time" slot-scope="row">
                    <div>
                        {{row.create_time.replace("T", " ")}}
                    </div>
                </template>
                <template slot="ope" slot-scope="row">
                    <div>
                        <a-dropdown>
                            <a class="ant-dropdown-link" @click="e => e.preventDefault()"><a-icon type="ellipsis" /></a>
                            <a-menu slot="overlay">
                                <a-menu-item>
                                    <a class="fs12">暂无可用操作</a>
                                </a-menu-item>
                            </a-menu>
                        </a-dropdown>
                    </div>
                </template>
            </a-table>
        </div>


        <a-modal
			title="新增公司文件"
			:visible="create_visiable"
			cancelText="取消"
			okText="提交"
			@cancel="create_visiable=false"
			@ok="createDocuments"
			:width="600"
		>
			<div>
				<a-form size="small">
					<div class="flex">
						<div class="flex-width">
							<a-form-item label="设置标题" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
								<a-input size="small" v-model="createForm.title" v-decorator="[ 'title', { rules: [{ required: true, message: '请输入标题' }] }, ]"
									placeholder="请输入标题"
								/>
							</a-form-item>
                            <a-form-item label="阅览权限" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
								<a-select class="" style="width: 50%;" v-model="createForm.all_read" size="small" placeholder="请选择">
                                    <a-select-option :value="1">
                                        所有人
                                    </a-select-option>
                                    <a-select-option :value="0">
                                        指定人员
                                    </a-select-option>
                                </a-select>
							</a-form-item>
                            <a-form-item v-if="createForm.all_read == 0" label="人员选择" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                                <ChoosePersonBox v-model="createForm.reader"></ChoosePersonBox>
							</a-form-item>
                            <a-form-item label="上传文件" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                                <div class="" v-if="createForm.attachments != null && createForm.attachments.length > 0">
                                    <div class="flex items-center m-attachment" v-for="(item, i) in createForm.attachments" :key="i">
                                        <a-icon type="paper-clip" class="mr10" />
                                        <div class="flex items-center">
                                            <a class="" @click="preview(item)" style="text-decoration:none;">
                                                <span>{{item.document_name}}</span>
                                            </a>
                                            <a-popconfirm
                                                title="是否确认删除?"
                                                ok-text="确定"
                                                cancel-text="取消"
                                                @confirm="removeAttachment(i)"
                                            > 
                                                <a-icon type="close" class="m-close ml10" style="text-align: right;" />
                                            </a-popconfirm>
                                        </div>
                                    
                                    </div>
                                </div>
                                <div class="">
                                    <a-upload multiple :data="projectFileItem" :before-upload="beforeUpload" :action="upload_url" :headers="headers" :remove="handleRemove" @change="onChangeAttachments" :showUploadList="false">
                                        <a-button size="small"> <a-icon type="upload" /> 上传附件 </a-button>
                                    </a-upload>
                                </div>
							</a-form-item>
						</div>
					</div>
				</a-form>
			</div>
		</a-modal>


        <a-modal
            :title="createForm.title"
			:width="600"
            cancelText="取消"
			okText="保存"
			@cancel="detail_visiable=false"
			@ok="updateCompanyDocuments"
			:visible="detail_visiable"
			:body-style="{ paddingBottom: '80px' }"
			@close="detail_visiable=false"
		>
            <div class="">
                <div class="bold">文件</div>
               
                <div class="mt10" v-if="createForm.attachments != null && createForm.attachments.length > 0">
                    <div class="flex items-center m-attachment" v-for="(item, i) in createForm.attachments" :key="i">
                        <!-- <a-icon type="paper-clip" class="mr10" />  -->
                        <a-icon type="vertical-align-bottom" @click="downFile(item)" class="mr10" />
                        <div class="flex items-center">
                            <a class="" @click="preview(item)" style="text-decoration:none;">
                                <span>{{item.document_name}}</span>
                            </a>
                            <a-popconfirm
                                title="是否确认删除?"
                                ok-text="确定"
                                cancel-text="取消"
                                @confirm="removeAttachment(i)"
                            > 
                                <a-icon v-if="userID == createForm.create_uid" type="close" class="m-close ml10" style="text-align: right;" />
                            </a-popconfirm>
                        </div>
                    </div>
                </div>
                <div class="mt10">
                    <a-upload multiple :data="projectFileItem" :action="upload_url" :headers="headers" :remove="handleRemove" @change="onChangeAttachments" :showUploadList="false">
                    <!-- <a-upload multiple :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload"> -->
                        <a-button size="small"> <a-icon type="upload" /> 上传附件 </a-button>
                    </a-upload>
                </div>
            </div>
        </a-modal>
        <a-modal
            :title="previewDoc.title"
            :visible="docVisible"
            width="100%"
            centered
            @cancel="docVisible=false"
            :footer="null"
            >
            <div v-if="previewDoc.docType == 1">
                <pdf :src="previewDoc.url" v-for="item in numPages"
                    :key="item"
                    :page="item"
                ></pdf>
            </div>
            <div v-else-if="previewDoc.docType == 2">
                <img :src="previewDoc.url" alt="" width="100%">
            </div>
            <div v-else>
                <VueDocPreview :value="previewDoc.url" :type="previewDoc.docType" />
            </div>
        </a-modal>
    </div>
</template>

<script>
import ChoosePersonBox from '../common/ChoosePersonBox.vue'
import ChoosePersonRadio from '../common/ChoosePersonRadio.vue'
import ProjectDetail from './ProjectDetail.vue'
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import pdf from 'vue-pdf'
import VueDocPreview from 'vue-doc-preview'

export default {
    components: { ChoosePersonBox, ChoosePersonRadio, ProjectDetail, pdf, VueDocPreview  },
    data() {
        return {
            locale,
            columns: [
                { title: '标题',  scopedSlots: { customRender: 'sub' } },
                { title: '状态',  scopedSlots: { customRender: 'status' } },
                { title: '创建人员', dataIndex: 'create_person'},
                { title: '创建时间', scopedSlots: { customRender: 'create_time' } },
                { title: '操作', scopedSlots: { customRender: 'ope' }, },
            ],
            projects: [],
            create_visiable: false,

            formItemLayout: {
                labelCol: { span: 4 },
                wrapperCol: { span: 18 },
            },
            formTailLayout: {
                labelCol: { span: 4 },
                wrapperCol: { span: 8, offset: 4 },
            },
			dateFormat: 'YYYY-MM-DD',

            detail_visiable: false,
            depart_id:null,
            userID:null,
            upload_url:"",
            headers:{},
            projectFileItem:{projectId:-1, file:{}},
            createForm:{attachments:[], all_read:1, reader:[]},
            docVisible:false,
            previewDoc: {
                title: "",
                isPdf: false,
                docType: 0
            },
            search:"",
            documentHtml:"",
        }
    },
    created() {
        // this.upload_url = this.$api.request_body.url + "/project/upload_assets";
        this.upload_url = this.$api.request_body.url + "/project/upload_company_docs";
		this.headers.token = this.$api.request_body.token;
        this.getCompanyDocuments();
        this.getAdminDepartID()
    },
    methods: {
        async getAdminDepartID() {
            let rs = await this.$api.getAdminDepartID();
            if (rs.err == 0) {
                this.depart_id = rs.data.data;
                this.userID = rs.user_id
            }
        },
        async getCompanyDocuments() {
            let rs = await this.$api.getCompanyDocuments(this.search);
            if (rs.err == 0) {
                for (let item of rs.data) {
                    item.key = item.id;
                    item.attachments = JSON.parse(item.attachments)
                    let s = item.create_time
                    item.create_time = new Date(s[0], s[1]-1, s[2], s[3], s[4], (s[5])?s[5]:0).Format("yyyy-MM-dd hh:mm:ss");
                }
                this.projects = rs.data;
            }
        },
        async getDocByProjectId(id){
            let rs = await this.$api.getDocByProjectId(id);
            if (rs.err == 0) {
                this.createForm.attachments = rs.data;
            }
        },
        async showAddUpload() {
            this.createForm = {id:0, attachments:[], all_read:1, reader:[]};
            this.create_visiable = true;
        },
        async createDocuments() {
            if(this.createForm.attachments.length == 0){
                this.$message.error("请上传附件")
                return;
            }
            let att = JSON.stringify(this.createForm.attachments) 
            let reader = JSON.stringify(this.createForm.reader) 
            let rs = await this.$api.uploadCompanyDocumnets(this.createForm.title, att, this.createForm.all_read, reader);
            if (rs.err == 0) {
                this.getCompanyDocuments();
                this.$message.success('提交成功！')
                this.create_visiable = false;
            }else{
                this.$message.error('提交失败！请稍后重试或联系管理员')
            }
        },
        seeDetail(row) {
            this.createForm.id = row.id 
            this.createForm.title = row.title 
            this.createForm.create_uid = row.create_uid
            let as = row.attachments 
            this.createForm.attachments = as
            this.detail_visiable = true;
        },
        handleRemove(file) {
            const index = this.fileList.indexOf(file);
            const newFileList = this.fileList.slice();
            newFileList.splice(index, 1);
            this.fileList = newFileList;
        },
        beforeUpload(file, fileList) {
            const isJpgOrPng = file.type === 'application/pdf';
            if (!isJpgOrPng) {
                this.$message.error('只能上传PDF文件');
                return false;
            }
            file.key = this.createForm.attachments.length + 1
            // this.fileList = [...this.fileList, file];
            // return false;
            return true;
        },
        removeAttachment(i) {
            if (this.createForm.attachments != null) {
                this.createForm.attachments.splice(i, 1);
            }

        },
        onChangeAttachments(info){
            const status = info.file.status;
            if (status !== 'uploading') {
            }
            if (status === 'done') {
                if(info.file.response.data.length == 0){
                    this.$message.error(`${info.file.name} 上传失败.`);
                }else{
                    this.createForm.attachments.push({document_name:info.file.name, document_link:info.file.response.data})
                    this.$message.success(`${info.file.name} 上传成功.`);
                }
            } else if (status === 'error') {
                this.$message.error(`${info.file.name} 上传失败.`);
            }
            this.$forceUpdate(this.createForm.attachments)
        },
        preview(src) {
            this.previewDoc.title = src.document_name
            let suffix = src.document_name.substring(src.document_name.lastIndexOf(".") + 1)
            if (suffix == "pdf") {
                const link = document.createElement('a');
                link.href = src.document_link;
                link.download = src.document_name; // 设置下载的文件名，根据实际需要修改
                link.target = '_blank'; // 在新窗口打开下载链接
                link.click(); // 模拟点击触发下载
            } else if (suffix == "png" || suffix == "jpg" || suffix == "jpeg") {
                this.previewDoc.docType ='2';
                this.previewDoc.url = src.document_link;
                this.docVisible = true;
            } else if(suffix == "docx" || suffix == "xlsx" || suffix == "pptx"){
                this.previewDoc.url = "https://api.hidocs.cn/api?furl=" + src.document_link;
                window.open(this.previewDoc.url)
            }else {
                this.previewDoc.docType = '3';
                // this.previewDoc.url = src.document_link;
                // this.previewDoc.isPdf = false;
                // this.previewDoc.docType = "office";
                // this.docVisible = true;

                this.previewDoc.url = "http://view.officeapps.live.com/op/view.aspx?src=" + encodeURIComponent(src.document_link);
                window.open(this.previewDoc.url)
                // window.open("https://view.xdocin.com/view?src=" + encodeURIComponent(src.document_link));

            }
            this.addReadCompanyDocRecord(src)
        },
        downFile(src){
            this.getBlob(src.url, (blob) => {
                this.saveAs(blob, src.name)
            })
        },
        downImg(src){
            this.getBlob(src.url, (blob) => {
                this.saveAs(blob, src.name)
            })
        },
        getBlob(url, cb) {
            var xhr = new XMLHttpRequest()
            xhr.open('GET', url, true)
            xhr.responseType = 'blob'
            xhr.onload = function() {
                if (xhr.status === 200) {
                cb(xhr.response)
                }
            }
            xhr.send()
        },
        saveAs(blob, filename) {
            if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, filename)
            }
            else {
                var link = document.createElement('a')
                var body = document.querySelector('body')

                link.href = window.URL.createObjectURL(blob)
                link.download = filename

                link.style.display = 'none'
                body.appendChild(link)

                link.click()
                body.removeChild(link)
                window.URL.revokeObjectURL(link.href)
            }
        },
        allowCostClear(){
            this.getCompanyDocuments()
        },
        async updateCompanyDocuments(){
            let att = JSON.stringify(this.createForm.attachments) 
            let rs = await this.$api.updateCompanyDocuments(this.createForm.id, att);
            if (rs.err == 0) {
                this.getCompanyDocuments();
                this.$message.success('保存成功！')
                this.detail_visiable = false;
            }else{
                this.$message.error('保存失败！请稍后重试或联系管理员')
            }
        },
        async addReadCompanyDocRecord(){
            let rs = await this.$api.addReadCompanyDocRecord(this.createForm.id);
            if (rs.err == 0) {
                
            }
        },

    }
}
</script>

<style lang="scss" scoped>
.flow-item {
    cursor: pointer;
    border: 1px solid rgba(0,0,0,0.1);
    padding: 5px 5px 5px 5px;
    font-size: 12px;
}
.select-flow-item {
    cursor: pointer;
    position: relative;
    .item {
        border-bottom: 1px solid rgba(0,0,0,0.1);
        padding: 5px 5px 5px 5px;
        font-size: 12px;
    }
}
.select-flow-item:not(:last-child):after {
    content: "";
    position: absolute;
    right: -10px;
    top: 23px;
    height: 2px;
    width: 10px;
    background: #d8d8d8;
}
.user_group {
    list-style-type: none;
    margin: 0;
    padding-left: 20px;
    padding-top: 10px;

    li {
        height: 30px;
        border: 1px solid rgba(0,0,0,0.05);
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        padding-left: 10px;
        cursor: pointer;

        &.active {
            background: #67C23A;
            color: white;
        }
    }
}
</style>

<style scoped>
/deep/.ant-table {
    font-size: 13px!important;
}
/deep/.ant-table-thead > tr > th {
    font-size: 14px!important;
}


</style>

<style lang="scss" scoped>
.m-attachment {
    padding: 5px;
    transition: all 0.3s;
    .m-close {
        opacity: 0;
        transition: all 0.3s;
    }
}
.m-attachment:hover {
    background-color: #f5f5f5;
    transition: all 0.3s;
    .m-close {
        opacity: 1;
        transition: all 0.3s;
    }
}
.img-card{
    display: table;
    float: left;
    width: 104px;
    height: 104px;
    margin-right: 8px;
    margin-bottom: 8px;
    text-align: center;
    vertical-align: top;
    background-color: #fafafa;
    border: 1px dashed #d9d9d9;
    border-radius: 4px;
    cursor: pointer;
    transition: border-color 0.3s ease;
}
</style>

<style scoped>
/deep/.ant-table-thead {
    background: #f0f2f5;
}
/deep/.ant-drawer-content {
    overflow: visible;
}
/deep/.ant-form-item {
    margin-bottom: 13px!important;
}
/deep/.ant-table {
    font-size: 13px!important;
}
</style>